import { useEffect } from "react"
import { useAuth } from "../../api/auth/store"
import { BranchData, useBranch } from "../../api/branch/store"
import CAccordion from "../../components/CAccordion"
import CStack from "../../components/CStack"
import ButtonControl from "../../components/ButtonControl"
import useUXStore from "../../api/ux/store"
import AddBranchView from "./AddBranchView"
import { ADMIN_ROLE, OWNER_ROLE, SUPPORT_ROLE } from "../../constants"
import EditableControl, { EditableLabel } from "../../components/EditableControl"
import { Col, Container, Row } from "react-bootstrap"

const defaultBranch: BranchData = { id: "", name: "" }

const AddBranchDialog = ({ com = "" }) => {
    const { refreshDialog } = useUXStore(state => state)
    const onAdd = () => {
        refreshDialog({
            id: "addBranch",
            visible: true,
            title: "Add Branch",
            content: <AddBranchView com={com} />,
            onConfirm: undefined,
        }, true)
    }
    return <>
        <ButtonControl text="Add Branch" variant="outline-primary" buttonLabel="Add" onClicked={onAdd} />
    </>
}

const BranchItem = ({ branch = defaultBranch,
    editable = true,
    onUpdate = (branch: BranchData) => { },
    onDelete = (branch: BranchData) => { }
}) => {
    const onApply = (new_data: BranchData) => {
        onUpdate(new_data)
    }
    return <CAccordion label={branch.name}>
        <EditableControl defaultData={branch} editable={editable} deletable onApply={onApply} onDelete={onDelete} className="">
            {(data, onChanged, edit) => (
                <Container>
                    <Row style={{ padding: 15 }}>
                        <Col >
                            <EditableLabel label="Id" value={data.id} />
                            <EditableLabel edit={edit} label="Name" value={data.name} onChanged={(val) => onChanged("name", val)} />
                        </Col>
                    </Row>
                </Container>
            )}
        </EditableControl>
    </CAccordion>
}

const Branches = () => {
    const { branches, retrieveBranches, removeBranch, updateBranch } = useBranch(state => state)
    const { currentCompany, hasRole } = useAuth(state => state)
    const { addToast } = useUXStore(state => state)
    useEffect(() => {
        retrieveBranches(currentCompany)
    }, [])
    const onUpdate = (branch: BranchData) => {
        updateBranch(branch, currentCompany)
            .then(code => {
                if (code === "200")
                    addToast("", "Branch " + branch.name + " was successfully updated.")
                else
                    addToast("", "Branch " + branch.name + " was failed to update.", null, "danger")
            })
    }
    const onDelete = (branch: BranchData) => {
        removeBranch(branch.id, currentCompany)
            .then(code => {
                if (code === "200")
                    addToast("", "Branch " + branch.name + " was successfully deleted.")
                else
                    addToast("", "Branch " + branch.name + " was failed to delete.", null, "danger")
            })
    }
    const addBranchEnabled = (hasRole(ADMIN_ROLE) || hasRole(OWNER_ROLE)) && !hasRole(SUPPORT_ROLE)
    const _branches = branches[currentCompany]
    if (!addBranchEnabled && (!_branches || _branches!.length === 0)) return <></>

    return <CStack header="Branches">
        {addBranchEnabled && <AddBranchDialog com={currentCompany} />}
        {_branches &&
            _branches!.map(branch => (
                <BranchItem editable={addBranchEnabled} key={branch.id + "bi"} branch={branch} onUpdate={onUpdate} onDelete={onDelete} />
            ))}
    </CStack>
}

export default Branches